import React from "react";
import classnames from "classnames";
import Styles from "./Intro.module.scss";
import { sanitize } from "isomorphic-dompurify";

interface IntroProps {
    text: string;
}

const Intro = ({ text }: IntroProps) => {
    return (
        <section className={Styles.main}>
            <div className={classnames(Styles.conainer, "container")}>
                <div className={Styles.intro} dangerouslySetInnerHTML={{ __html: sanitize(text) }} />
            </div>
        </section>
    );
};

export default Intro;
